export default "__VITE_ASSET__BLG_baug__"